import customise from "./customise"

export default {
  // namespaced: true,
	modules: {
		customise
	}
}
